import { useIsBackNavigationHandler } from './IsBackNavigationHandler.presenter';

export const IsBackNavigationHandler = (): null => {
  useIsBackNavigationHandler();

  return null;
};
